import { render, staticRenderFns } from "./RadioElement.vue?vue&type=template&id=7a15a09a&"
import script from "./RadioElement.vue?vue&type=script&lang=ts&"
export * from "./RadioElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports